import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from 'sonner'
import App from './App.tsx'
import { ThemeProvider } from './components/ThemeProvider'
import { queryClient } from './lib/queryClient'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
        <Toaster richColors position="top-right" />
        {import.meta.env.DEV && <ReactQueryDevtools buttonPosition="bottom-left" />}
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
